// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".left-align[data-v-43bd49f4]{text-align:left}", ""]);
// Exports
module.exports = exports;
